import { config } from '../../lib/config';
import { googleCalendarBookingUrl, googleCalendarEmbedUrl } from '../../lib/googleCalendar';

type Props = {
  bookingUrl?: string;
  embedUrl?: string;
  title?: string;
};

/** Live Google Appointment Schedule (availability + booking handled by Google). */
export default function GoogleAppointmentEmbed({
  bookingUrl = config.googleCalendarBookingUrl,
  embedUrl = config.googleCalendarEmbedUrl,
  title = 'Video Call scheduling',
}: Props) {
  const pageUrl = googleCalendarBookingUrl(bookingUrl);
  const iframeSrc = googleCalendarEmbedUrl(bookingUrl, embedUrl);

  return (
    <div className="book-call-google-embed">
      <iframe
        className="book-call-google-embed__frame"
        src={iframeSrc}
        title={title}
        loading="lazy"
        scrolling="no"
        referrerPolicy="no-referrer-when-downgrade"
      />
      <p className="book-call-google-embed__fallback">
        Calendar not loading?{' '}
        <a href={pageUrl} target="_blank" rel="noopener noreferrer">
          Open the scheduler in Google Calendar
        </a>
        .
      </p>
    </div>
  );
}
